/*eslint-disable*/
import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
// @material-ui/icons
import logo from "assets/images/logo_reverse.png";
import Mail from "@material-ui/icons/Mail";
import Favorite from "@material-ui/icons/Favorite";
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Footer from "components/Footer/Footer.js";

import styles from "assets/jss/material-kit-pro-react/views/componentsSections/footerStyle.js";
import customerDetailsStyles from "assets/jss/material-kit-pro-react/views/cspDashboard/customerDetailsStyles.js";

const useStylesCustomerDetailsStyles = makeStyles(customerDetailsStyles);
const useStyles = makeStyles(styles);

export default function SectionFooter() {
	const classes = useStyles();
	const classesCSStyles = useStylesCustomerDetailsStyles();

	return (
		<>
			<div>
				<hr className={classNames(classes.lineFooter)} />
			</div>
			<Footer
				theme="white"
				content={
					<GridContainer>
						<GridItem xs={12} sm={6} md={6}>
							<div className={classNames(classes.copyRight)}>
								&copy; {1900 + new Date().getYear()} {""}
								<a href="https://auscomp.au" target="_blank">
									Auscomp
								</a>{" "}
								All rights reserved. • Privacy Policy • Terms of Service
							</div>
						</GridItem>
						<GridItem xs={12} sm={6} md={6}>
							<ul className={classes.socialButtons}>
								<li>
									<Button justIcon simple href="#pablo" color="twitter">
										<i className="fab fa-twitter" />
									</Button>
								</li>
								<li>
									<Button justIcon simple href="#pablo" color="facebook">
										<i className="fab fa-facebook-square" />
									</Button>
								</li>
								{/* <li>
								<Button justIcon simple href="#pablo" color="dribbble">
									<i className="fab fa-dribbble" />
								</Button>
							</li> */}
								<li>
									<Button justIcon simple href="#pablo" color="google">
										<i className="fab fa-google-plus-g" />
									</Button>
								</li>
								{/* <li>
								<Button justIcon simple href="#pablo" color="youtube">
									<i className="fab fa-youtube" />
								</Button>
							</li> */}
							</ul>
						</GridItem>
					</GridContainer>
				}>
				<div className={classes.footer}>
					<GridContainer>
						<GridItem xs={12} sm={3} md={3}>
							<div className={classNames(classes?.footerSaasLogo)}>saas.</div>
							<div className={classNames(classes?.footerSaasBottom)}>auscomp.au</div>
						</GridItem>
						<GridItem
							xs={12}
							sm={2}
							md={2}
							className={classNames(classesCSStyles?.mB)}>
							<div className={classNames(classes.footerHeader)}>Quick Links</div>
							<ul className={classNames(classes.footerLinks)}>
								<li>
									<a href="/" className={classNames(classes.block, classes.liUrlA)}>
										Home
									</a>
								</li>
								<li>
									<a
										href="#about-us"
										className={classNames(classes.block, classes.liUrlA)}>
										About
									</a>
								</li>
								<li>
									<a
										href="#product-portfolio"
										className={classNames(classes.block, classes.liUrlA)}>
										Services
									</a>
								</li>
								<li>
									<a
										href="#contact"
										className={classNames(classes.block, classes.liUrlA)}>
										Contact
									</a>
								</li>
							</ul>
						</GridItem>
						<GridItem xs={12} sm={2} md={2}>
							<div className={classNames(classes.footerHeader)}>Contact</div>
							<ul className={classes.footerLinks}>
								<li>
									<a
										href="mailto:sales@auscomp.au"
										className={classNames(classes.block, classes.liUrl)}>
										sales@auscomp.au
									</a>
								</li>
								<li>
									<a
										href="https://auscomp.au"
										target="_blank"
										className={classNames(classes.block, classes.liUrl)}>
										auscomp.au
									</a>
								</li>
								<li>
									<a
										href="tel:1300504101"
										onClick={(e) => e.preventDefault()}
										className={classNames(classes.block, classes.liUrl)}>
										1300 504 101
									</a>
								</li>
							</ul>
						</GridItem>
						<GridItem xs={12} sm={3} md={3}>
							<div className={classNames(classes.footerHeader)}>Locations</div>
							<ul className={classes.footerLinks}>
								<li>
									<div className={classes.address}>
										38 Nashos Place,
										<br /> WACOL, QLD 4076.
									</div>
								</li>
								<li>
									<div className={classes.address}>
										7/17 George Young Street,
										<br /> AUBURN, NSW 2144.
									</div>
								</li>
							</ul>
						</GridItem>
						<GridItem xs={12} sm={2} md={2} className={classes.subscribe}>
							<div className={classNames(classes.footerHeader, classes)}>
								Subscribe to Newsletter
							</div>
							<form>
								<div className={classNames(classes.footerInput)}>
									<CustomInput
										id="footeremail"
										formControlProps={{
											fullWidth: false,
											className: classes.customFormControl,
										}}
										inputProps={{
											placeholder: "Email Address",
											type: "email",
										}}
									/>
									{/* <Button color="primary" justIcon>
								<Mail />
							</Button> */}
									<button
										className={classNames(classesCSStyles.buttonPrimary)}
										type="submit">
										<span className={classNames(classesCSStyles.buttonText)}>
											Subscribe
										</span>
									</button>
								</div>
							</form>
						</GridItem>
					</GridContainer>
				</div>
			</Footer>
		</>
	);
}
{
	/* <GridContainer>
						<GridItem xs={12} md={2} sm={2}>
							<div className={classes.left}>
								<img src={logo} alt="logo" className={classes.footerLogo} />
							</div>
						</GridItem>
						<GridItem xs={12} md={7} sm={7}>
							<div className={classes.pullCenter}>
								<div className={classes.footerTitle}>
									Looking to become a reseller, get a quote, or book a cloud
									consultation?
								</div>
								<List className={classes.list}>
									<ListItem className={classes.inlineBlock}>
										<a href="mailto:sales@auscomp.au" className={classes.block}>
											📧 sales@auscomp.au
										</a>
									</ListItem>
									<ListItem className={classes.inlineBlock}>
										<a
											href="https://auscomp.au"
											target="_blank"
											className={classes.block}>
											🌐 www.auscomp.au
										</a>
									</ListItem>
									<ListItem className={classes.inlineBlock}>
										<a
											href="tel:1300504101"
											onClick={(e) => e.preventDefault()}
											className={classes.block}>
											📱 Call us: 1300 504 101
										</a>
									</ListItem>
								</List>
							</div>
						</GridItem>
						<GridItem md={3} sm={3}>
							<GridContainer>
								<GridItem xs={12} md={6} sm={6}>
									<div className={classes.address}>
										<span>
											<i className="fas fa-location-arrow" />
										</span>
										Auscomp QLD <br />
										38 Nashos Place, WACOL, QLD 4076.
									</div>
								</GridItem>
								<GridItem xs={12} md={6} sm={6}>
									<div className={classes.address}>
										<span>
											<i className="fas fa-location-arrow" />
										</span>
										Auscomp NSW <br />
										7/17 George Young Street, AUBURN, NSW 2144.
									</div>
								</GridItem>
							</GridContainer>
						</GridItem>
					</GridContainer> */
}
